<script setup lang="ts">
type BreadcrumbItem = {
  label: string
  to?: string
}

const props = withDefaults(defineProps<{
  items: BreadcrumbItem[]
  centered?: boolean
}>(), {
  centered: false
})
</script>

<template>
  <div
    class="flex flex-wrap items-center gap-2 text-sm text-gray-400"
    :class="{ 'justify-center': props.centered }"
  >
    <NuxtLink
      to="/"
      class="hover:text-white transition-colors"
    >
      Home
    </NuxtLink>
    <span>»</span>
    <template
      v-for="(item, index) in props.items"
      :key="`${item.label}-${index}`"
    >
      <NuxtLink
        v-if="item.to"
        :to="item.to"
        class="hover:text-white transition-colors"
      >
        {{ item.label }}
      </NuxtLink>
      <span v-else>{{ item.label }}</span>
      <span v-if="index < props.items.length - 1">»</span>
    </template>
  </div>
</template>
